export default "__VITE_ASSET__BbmVXDGx__"